import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './App.scss';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Content from './pages/Content';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="app-container">
          <div className="app-body">
            <Switch>
              <Route path="/" exact> <Home /> </Route>
              <Route path="/privacy" exact> <Privacy /> </Route>
              <Route path="/terms" exact> <Terms /> </Route>
              <Route path="/content" exact> <Content /> </Route>
            </Switch>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
